/**
 * portatour-specific rules
 * requires common
 */

jQuery.validator.addMethod("rangebracketed", function(value, element, param) {
	
	var numbers = new RegExp("^[0-9"+ptNumber.dec_point+ptNumber.thousands_sep+"]+$");
	
	if(value.match(numbers) == null) {
    return false;
  }
  
  if(typeof value == "string")
		value = ptNumber.sparseNumber(value);
	
  if (this.optional( element )) {
    $(element).data('rangebracketedResult', value);
    return true;
  } else if (value < param[ 0 ]) {
    return false;
  } else if (value > param[ 1 ] ) {
    return false;   
  } else {
    $(element).data('rangebracketedResult', value); // value OK, write value into rangebracketedResult
    return true;  
  }
}, function(params){
	// country specific param error message formating is done here ',' or '.' seperator
	fr = params[0];
	to = params[1];
	if(typeof fr == 'string') fr = ptNumber.sparseNumber(fr);
	if(typeof to == 'string') to = ptNumber.sparseNumber(to);	
	
	fr = ptNumber.sprintNumber(fr,ptNumber.countDecimals(fr));
	to = ptNumber.sprintNumber(to,ptNumber.countDecimals(to));
	return jQuery.validator.messages.range([fr, to]);}
); 

jQuery.validator.addMethod("integer", function(value, element, param) {
	
	if(typeof value == 'string') value = ptNumber.sparseNumber(value);
	
	if(value == Math.trunc(value))
		return true;
	
	return false;

}, function(params){
	return ptMessages.integererror;}
); 



/**
 * ptSimpleForm_date : rule to check if a datepicker has a valid date
 *
 * Requires $.datepicker for formatting of dates.
 * 
 * Params: 
 *  dateformat : The date format. Default if not set is to use pGetDateFormat().
 * usage:
 * myfield: { ptSimpleForm_date: {} } 
 */
jQuery.validator.addMethod("ptSimpleForm_date", 
  function(value, element, params) {
	
		if (!params.dateFormat) {
			params.dateFormat = pGetDateFormat();
		}
						
		var dateFormat = params.dateFormat;
		
		try {
			var valueAsDate = $.datepicker.parseDate( dateFormat, value )
			if (valueAsDate == null)
				return false;
			else
				return true; // it parsed
		} catch (x) {
			return false; // exception when parsing
		}
  },
  // errormessage function
  function (params) {
  	return pLang__('ptSimpleForm_date');
  }
);

/**
 * for the given params of a validator rule ptSimpleForm_minDate ptSimpleForm_date,
 * return the date to be used to initialize a datepicker or to use as comparison for mindate
 * FS#20646 - only consider working days!!!
 */
function ptSimpleForm_date_calc(params) {
	
	var skipWeekends = true;
	
	if(typeof params.noWeekends != 'boolean') {
		skipWeekends = false;
	} else {
		skipWeekends = params.noWeekends;
	}	
	if (params.minDate) {
		if (typeof params.minDate == 'number') {
			const oneDayMillis = 24 *60 * 60 * 1000;
		  var minDate = new Date(); // set to today
		  var addedDays = 0;
		  while(addedDays != params.minDate) {
		  	
		  	minDate.setTime(minDate.getTime() + oneDayMillis);
		  	addedDays = addedDays + 1;
		  	
		  	//we want to only count work days so remove one day when skipweekends and sat or sun
		  	if(skipWeekends && (minDate.getDay() == 6 || minDate.getDay() == 0) ) {
		  		addedDays = addedDays - 1;
		  	}
		  }
		  
		  minDate.setHours(0); // make it 00:00:0
			minDate.setMinutes(0);
			minDate.setSeconds(0);
			minDate.setMilliseconds(0);
						
			return minDate;
		} else {
			return params.minDate;
		}
	} else {
		return new Date(); // set to today
	}
}


/**
 * ptSimpleForm_minDate : rule to check if a datepicker has a minimum date
 *
 * Requires $.datepicker for formatting of dates.
 * 
 * Params: 
 *  dateformat : The date format. Default if not set is to use pGetDateFormat().
 *  minDate : 
 *     Date() object: use this date as mindate
 *     0 : is "today"
 *     1..n (integer) : use today + these days
 *  noWeekends : if true, weekends are not valid. If minDate is used and noWeekends, the mindate will be increased up to the next weekday.
 * usage:
 * myfield: { minDate: { 
	    dateformat: 'm/d/yy',
	    minDate:  0
	 } }
 */
jQuery.validator.addMethod("ptSimpleForm_mindate", 
  function(value, element, params) {
	
		if (!params.dateFormat) {
			params.dateFormat = pGetDateFormat();
		}
		if (typeof(params.minDate) == 'undefined' )
			throw 'params missing minDate';
						
		var dateFormat = params.dateFormat;
		
		var minDate = ptSimpleForm_date_calc(params);
		
		// pass the mindate to the error message, if needed
		params.calculatedMinDate = $.datepicker.formatDate(dateFormat, minDate);
		
		try {
			var valueAsDate = $.datepicker.parseDate( dateFormat, value )
			return (valueAsDate >= minDate);
		} catch (x) {
			return false;
		}
  },
  // errormessage function
  function (params, element) {
		// TODO: FS#20144 is it possible to pass min condition to the error message function?
  	return pLangF__('ptSimpleForm_mindate', params);
  }
);





/**
 * ptSimpleForm_noWeekends : rule to check if a datepicker is a workday
 *
 * Requires $.datepicker for formatting of dates.
 * 
 * Params: 
 *  dateformat : The date format. Default if not set is to use pGetDateFormat().
 * usage:
 * myfield: { ptSimpleForm_noWeekends: { dateformat: 'm/d/yy' }}
 */
jQuery.validator.addMethod("ptSimpleForm_noWeekends", 
  function(value, element, params) {
	
		if (!params.dateFormat) {
			params.dateFormat = pGetDateFormat();
		}
						
		var dateFormat = params.dateFormat;
		
		try {
			var valueAsDate = $.datepicker.parseDate( dateFormat, value )
			// verify noWeekends
			return (valueAsDate.getDay() > 0 && valueAsDate.getDay() < 6); 
		} catch (x) {
			return false;
		}
  },
  // errormessage function
  function (params, element) {
  	return pLang__('ptSimpleForm_noWeekends');
  }
);



/**
 * FS#13701: validation for brazilian phone numbers
 */
jQuery.validator.addMethod('ptSimpleForm_brPhone', 
	function(value) { 
		return (value.replace(/[^0-9]/g,"").length > 9); 
	},
	function (params, element) {
		return pLang__('brPhoneErrorMessage');
	}
);


/**
 * ptSimpleForm_email is implemented by tweaking the parameters of remote.
 * see ptSimpleForm
 */
// jQuery.validator.addMethod('ptSimpleForm_email',
